{
    "title": "Employment and Occupation",
    "input":{
        "employmentStatus": "Employment Status",
        "employmentDescription": "Employment Description",
        "employerName": "Employer Name",
        "occupation": "Occupation"
    }
}